export default __webpack_public_path__ + "static/media/adv-3.1b645108.jpg";